import { useState } from "react"
import { Data, Column, FieldType, UIPermission, SpinnerDiv } from "../../../../features/ui"
import { DataTypeList } from "../../../../features/data-types"
import { useSystemStateHooks } from "../../../system"
import { DataType } from "../../../../tables"
import { Category } from "../../state/types"
import { CategoryFilters } from "./categoryFilters"

type Props = {
    categories: Category[]
}

export const CategoryList = (props: Props) => {
    const { categories } = props

    const [rows, setRows] = useState<Data[]>([])
    const [asyncDataLoaded, setAsyncDataLoaded] = useState(false)

    const { userHasPermission } = useSystemStateHooks()
    const readOnly = !userHasPermission(UIPermission.SAVE_CATEGORIES)

    const columns: Column[] = [
        {
            name: 'imageUrl',
            type: FieldType.IMAGE,
            label: ' '
        },
        {
            name: 'name',
            type: FieldType.TEXT,
            label: 'Nombre'
        }
    ]

    const onSearchStart = () => setAsyncDataLoaded(false)

    const onSearchDone = (dataTypes: DataType[]) => {
        setRows(dataTypes as Category[])
        setAsyncDataLoaded(true)
    }

    const renderAsync = (element: JSX.Element) => asyncDataLoaded ? element : <SpinnerDiv />

    return (
        <>
            <CategoryFilters
                categories={categories}
                onSearchStart={onSearchStart}
                onSearchDone={onSearchDone}
            />
            {renderAsync(
                <DataTypeList
                    columns={columns}
                    rows={rows}
                    readOnly={readOnly}
                    showDetail={false}
                />
            )}
        </>
    )
}
